import { useAtom } from 'jotai';

import { heidi2OnboardingLaunchAtom } from '../heidi-2-onboarding-launch-atom';

import type { Heidi2AwarenessBannerPorts } from './heidi-2-awareness-banner-ports';
import { Heidi2OnboardingHost } from './heidi-2-onboarding-host';

/**
 * Mounts the Heidi II tour when something asks to reopen it part-way in — the
 * explore-later banner or the checklist. Separate from the first-run host in
 * `Heidi2AwarenessBanner`, whose audience is still on Heidi 1.
 */
export const Heidi2OnboardingRelaunch = ({
  ports,
}: {
  ports: Heidi2AwarenessBannerPorts;
}) => {
  const [launch, setLaunch] = useAtom(heidi2OnboardingLaunchAtom);

  if (!launch) return null;

  return (
    <Heidi2OnboardingHost
      ports={ports}
      initialStep={launch.startAt}
      onFinished={() => {
        setLaunch(null);
      }}
    />
  );
};
